/* eslint-disable */
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Override Settings
var bcSfFilterSettings = {
    general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    requestInstantly: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
    'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
    // Grid Template
    'productGridItemHtml': '<div class="card-grid__item">' +
        '<div class="card card--product">' +
            '{{itemImages}}' +
            '<div class="card__footer">' +
                '<a class="card__link test" href="{{itemUrl}}">{{itemTitle}}</a><br>' +
            '{{itemPrices}}' +
  			'{{bundleDiscount}}' +
            '</div>' +
        '</div>' +
    '</div>',
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&lsaquo;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&lsaquo;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rsaquo;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rsaquo;</span></li>',

    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
    // Sorting Template
    'sortingHtml': '<select class="bc-sf-filter-filter-dropdown" aria-label="item sorting">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown" aria-label="item sorting">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    return data;
}


/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Add item Images
    var itemImagesHtml = '';
    if (images.length > 0) {
        itemImagesHtml += '<a class="card__link" href="{{itemUrl}}">';
        if (data.tags.length > 0) {
            itemImagesHtml += '<div class="card__badge-listing">';
            for (var i = 0; i < data.tags.length; i++) {
                if (data.tags[i].toLowerCase().indexOf('badge:') > -1) {
                    console.log(data.tags[i].split(':'));
                    itemImagesHtml += '<div class="card__badge badge badge--secondary">';
                    itemImagesHtml += '<span>' + data.tags[i].split(':')[1] + '</span>';
                    itemImagesHtml += '</div>';
                }
            }
            itemImagesHtml += '</div>';
        }
        var thumbUrl = bcSfFilterConfig.general.no_image_url,
            thumbFlipUrl = bcSfFilterConfig.general.no_image_url;
        var aspectRatio = 1;
        itemImagesHtml += '<div class="card__thumbnail-container">';
        if (images.length > 0) {
            thumbUrl = this.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
            aspectRatio = images[0]['width'] / images[0]['height'];
            itemImagesHtml += '<div id="ImageWrapper-{{itemId}}-' + (index - 1) + '" data-image-id="' + images[0]['id'] + '" class="responsive-card-image__wrapper card__thumbnail card__thumbnail--primary">' +
                '<img class="responsive-card-image__image lazyload blur-up" src="' + this.optimizeImage(images[0]['src'], 'large') + '" ' +
                'data-src="' + thumbUrl + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]" ' +
                'data-aspectratio="' + aspectRatio + '" data-sizes="auto" tabindex="-1" alt="{{itemTitle}}"' +
                '>' +
                '</div>' +
                '<noscript>' +
                '<img src="' + this.optimizeImage(images[0]['src'], '2048x2048') + '" alt="{{itemTitle}}">' +
                '</noscript>';
            if (images.length > 1) {
              thumbFlipUrl = this.optimizeImage(images[1]['src'], '1x1').replace('_1x1.', '_{width}x.');
              itemImagesHtml += '<div id="ImageWrapper-{{itemId}}-' + index + '" data-image-id="' + images[1]['id'] + '" class="responsive-card-image__wrapper card__thumbnail card__thumbnail--secondary">' +
                  '<img class="responsive-card-image__image lazyload blur-up" src="' + this.optimizeImage(images[1]['src'], 'large') + '" ' +
                  'data-src="' + thumbFlipUrl + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]" ' +
                  'data-aspectratio="' + aspectRatio + '" data-sizes="auto" tabindex="-1" alt="{{itemTitle}}"' +
                  '>' +
                  '</div>' +
                  '<noscript>' +
                  '<img src="' + this.optimizeImage(images[1]['src'], '2048x2048') + '" alt="{{itemTitle}}">' +
                  '</noscript>';
            }
        } else {
            itemImagesHtml += '<div data-asp="' + aspectRatio + '" style="padding-top: 100%">' +
                '<img src="' + thumbUrl + '" alt="{{itemTitle}}" class="product__img">' +
                '</div>';
        }
        if (bcSfFilterConfig.custom.enable_quick_view) {
            itemImagesHtml += '<div class="card__button button button--primary button--block button--small" js-quick-view="toggle" data-product-url="/products/{{itemHandle}}">Quickview</div>';
        }
        itemImagesHtml += '</div>';
        itemImagesHtml += '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
    // Add item Prices
    var itemPricesHtml = '';
    if (onSale) {
        itemPricesHtml += '<s>' + this.formatMoney(data.compare_at_price_min, this.moneyFormat).replace(".00", "") + '</s> ';
        itemPricesHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label_basic.regular_price + '</span> ';
        if (priceVaries) {
            itemPricesHtml += '<span class="compare-price">' + bcSfFilterConfig.label_basic.on_sale.replace(/{{ price }}/g, this.formatMoney(data.price_min, this.moneyFormat)).replace(".00", "") + '</span>';
        } else {
            itemPricesHtml += '<span class="compare-price">' + this.formatMoney(data.price_min, this.moneyFormat).replace(".00", "") + '</span>';
        }
    } else {
        if (priceVaries) {
            itemPricesHtml += bcSfFilterConfig.label_basic.from.replace(/{{ price }}/g, this.formatMoney(data.price_min, this.moneyFormat)).replace(".00", "");
        } else {
            itemPricesHtml += this.formatMoney(data.price_min, this.moneyFormat).replace(".00", "");
        }
    }
    if (soldOut) {
        itemPricesHtml += bcSfFilterConfig.label_basic.sold_out;
    }

    itemHtml = itemHtml.replace(/{{itemPrices}}/g, itemPricesHtml);
  
    var bundleDiscountHtml = '';
//     console.log(data);

    data.tags.forEach(function(tag){
      if( tag.includes('-Bundle') ){
        bundleDiscountHtml += '<div class="discountMessage"><p>2 For 20%, 3 For 30% Off</p></div>';
      }
    });
    
    itemHtml = itemHtml.replace(/{{bundleDiscount}}/g, bundleDiscountHtml);

    //   // Add data json
    //   var self = this;
    //   var itemJson = {
    //     "id": data.id,
    //     "title": data.title,
    //     "handle": data.handle,
    //     "vendor": data.vendor,
    //     "variants": data.variants,
    //     "url": self.buildProductItemUrl(data),
    //     "options_with_values": data.options_with_values,
    //     "images": data.images,
    //     "available": data.available,
    //     "price_min": data.price_min,
    //     "price_max": data.price_max,
    //     "compare_at_price_min": data.compare_at_price_min,
    //     "compare_at_price_max": data.compare_at_price_max
    //   };
    //   itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

    //   // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    //   itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }
    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;
        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 1 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
      	
//         if (currentPage> 0) {
//             beforeCurrentPageArr.unshift('of');
//         }
//         if (currentPage >= 0) {
//             beforeCurrentPageArr.unshift(1);
//         }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 1 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
            afterCurrentPageArr.push('of');

            afterCurrentPageArr.push(totalPage);


        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == 'of') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      	console.log(paginationHtml);
        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/
var first_load = false;
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');
        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            sortingItemsHtml += '<option value="default" style="display:none;">' + bcSfFilterConfig.label.sorting + '</option>';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);
            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
        if (!first_load) {
            jQ(this.selector.topSorting + ' select').val('default');
            first_load = true;
        }
    }
};



/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
    jQ('.bc-sf-filter-product-item-main-image').load(function () {
        var imageContainer = jQ(this).parent();
        imageContainer.css('width', '100%').css('height', $(this).height());
    }).each(function () {
        if (this.complete) jQ(this).load();
    });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if (self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != '') {
        alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        } else {
            if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
                bcActionList.initFlag = false;
                bcActionList.alInit(bcSfFilterParams, bcAlParams);
            } else {
                bcActionList.alInit();
            }
        }
    }
    /* end-initialize-bc-al */
    // Call theme init function
    if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
        jQ(theme.init);
    }
    // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    var _this = this;
    var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
    if (data.total_product == 1) {
        totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
    }
    jQ('#bc-sf-filter-total-product').html(totalProduct);

    jQ('.bc-sf-filter-clear-all').on('click', function () {
        $(this).remove();
    });
    matchHeightImage();
    jQ(window).resize(function () {
        matchHeightImage();
    });

    // Prevent double tap on iOS
    if (this.isMobile()) {
        jQ('.bc-sf-filter-product-item').find('a')
            .on('touchstart', function () {
                isScrolling = false;
            })
            .on('touchmove', function (e) {
                isScrolling = true;
            })
            .on('touchend', function (e) {
                if (!isScrolling) {
                    window.location = jQ(this).attr('href');
                }
            });

        // Insert the sort dropdown into the main filter dropdown 
        jQ('#bc-sf-filter-top-sorting').appendTo('#bc-sf-filter-options-wrapper').addClass('bc-sf-filter-option-block');
        jQ('#bc-sf-filter-total-product').prependTo('.count-clear');
    }
};

// Build Filter Options selected by parsing params from url
BCSfFilter.prototype.buildFilterSelection = function (data) {
    var selectionContent = this.buildFilterSelectionData(data);
    var verticalContent = selectionContent[0],
        horizontalContent = selectionContent[1];
    var clearAllButtonHtml = this.buildClearAllButton();
    // Build content & Append to Filter tree
    if (verticalContent != '') {
        var verticalHtml = this.getTemplate('filterRefineWrapper');
        verticalHtml = verticalHtml.replace(/{{label}}/g, this.getSettingValue('label.refine'));
        verticalHtml = verticalHtml.replace(/{{selectedItems}}/g, verticalContent);
        verticalHtml = this.buildFilterTreeClass(verticalHtml);
        this.addFilterTreeItem(verticalHtml, 'before', 'vertical');
        // Build Clear All button
        jQ(this.selector.filterTree).find('.' + this.class.filterRefineWrapper + ' .' + this.class.filterBlockTitle).append(clearAllButtonHtml);
    }
    var selectionHorizontalPlace = this.getSettingValue('general.selectionHorizontalPlace');
    if (selectionHorizontalPlace != '#bc-sf-filter-tree-h') {
        jQ(selectionHorizontalPlace).empty();
    }
    if (horizontalContent != '') {
        var horizontalHtml = this.getTemplate('filterRefineHorizontalWrapper');
        horizontalHtml = horizontalHtml.replace(/{{label}}/g, this.getSettingValue('label.refine'));
        horizontalHtml = horizontalHtml.replace(/{{selectedItems}}/g, horizontalContent);
        horizontalHtml = this.buildFilterTreeClass(horizontalHtml);
        if (this.getSettingValue('general.refineByHorizontalPosition') == 'top') {
            this.addFilterTreeItem(horizontalHtml, 'before', 'horizontal', selectionHorizontalPlace);
        } else {
            this.addFilterTreeItem(horizontalHtml, 'after', 'horizontal', selectionHorizontalPlace);
        }
        // Build Clear All button
        if (jQ('.template-collection__filters-results-wrapper .bc-sf-filter-pc .bc-sf-filter-clear-all').length > 0) {
            jQ('.template-collection__filters-results-wrapper .bc-sf-filter-pc .bc-sf-filter-clear-all').remove();
        }
        if (jQ('.row--mobile .bc-sf-filter-pc .bc-sf-filter-clear-all').length > 0) {
            jQ('.row--mobile .bc-sf-filter-pc .bc-sf-filter-clear-all').remove();
        }
        jQ('.bc-sf-filter-pc.' + this.class.filterRefineWrapper).append(clearAllButtonHtml);
    }
};




// Build Default layout
function buildDefaultLink(a, b) { var c = window.location.href.split("?")[0]; return c += "?" + a + "=" + b } BCSfFilter.prototype.buildDefaultElements = function (a) { if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) { var b = bcSfFilterConfig.general.collection_count, c = parseInt(this.queryParams.page), d = Math.ceil(b / this.queryParams.limit); if (1 == d) return jQ(this.selector.pagination).html(""), !1; if ("default" == this.getSettingValue("general.paginationType")) { var e = bcSfFilterTemplate.paginateHtml, f = ""; f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f); var g = ""; g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g); for (var h = [], i = c - 1; i > c - 3 && i > 0; i--)h.unshift(i); c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c); for (var j = [], k = c + 1; k < c + 3 && k <= d; k++)j.push(k); c + 3 < d && j.push("..."), c + 3 <= d && j.push(d); for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)"..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n])); e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e) } } if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) { jQ(this.selector.topSorting).html(""); var o = this.getSortingList(); if (o) { var p = ""; for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>"; var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p); jQ(this.selector.topSorting).html(r); var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting; jQ(this.selector.topSorting + " select").val(s), jQ(this.selector.topSorting + " select").change(function (a) { window.location.href = buildDefaultLink("sort_by", jQ(this).val()) }) } } };

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) { for (var k = 0; k < data.length; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; for (var i = 0; i < data[k]['options_with_values'].length; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { for (var i = 0; i < data[k]['variants'].length; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; for (var i = 0; i < data[k]['variants'].length; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { for (var j = 0; j < variantOptions.length; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html'] } return data };

// Customised height of scroll on pagination click
BCSfFilter.prototype.buildDefaultPaginationEvent = function(a) {
    var b = this
      , c = this.getSelector("pagination");
    parseInt(this.queryParams.page);
    jQ(c).find("a").unbind("click"),
    jQ(c).find("a").on("click", function(a) {
        a.preventDefault(),
        b.internalClick = !0;
        var c = jQ(this).attr("href");
        b.onChangeData(c, "page"),
        jQ("body,html").animate({
            scrollTop: jQ(b.getSelector("products")).position().top - 178
        }, 600)
    })
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
